package com.tovtalk.data.mapper

import kotlin.time.Instant

/**
 * Shared ISO-8601 instant parser used across all DTO→entity mappers.
 * Falls back to epoch 0 on unparseable input so a single bad timestamp
 * never crashes a whole list mapping.
 */
internal fun parseInstant(dateString: String): Instant {
    return try {
        Instant.parse(dateString)
    } catch (e: Exception) {
        Instant.fromEpochMilliseconds(0)
    }
}
